export default (n: number, min: number, max: number) =>
    Math.max(min, Math.min(max, n));
